// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@expo/webpack-config/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollList::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.scrollList {\r\n    -ms-overflow-style: none;\r\n    /* IE and Edge */\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n}", ""]);
// Exports
module.exports = exports;
